import { ChangeDetectorRef, Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { Occupation, OccupationService } from 'taxtank-core';
import { NgControl } from '@angular/forms';
import { AbstractAutocompleteComponent } from '@shared/component/form-controls/autocomplete/abstract-autocomplete/abstract-autocomplete.component';
import { Observable } from 'rxjs';

/**
 * Occupation autocomplete
 */
@Component({
  selector: 'app-occupation-autocomplete',
  templateUrl: './occupation-autocomplete.component.html',
  styleUrls: ['./occupation-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class OccupationAutocompleteComponent extends AbstractAutocompleteComponent<Occupation> {
  private occupationService = inject(OccupationService);

  @Input() label = 'Occupation';

  getOptions$(): Observable<Occupation[]> {
    return this.occupationService.getOccupations();
  }
}
